import { createAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api, apiNoAuth } from '../../config/api';

const initial = {
  isUserAndRoleAnalyticsLoading: false,
  isUserAndRoleAnalyticsSuccess: false,
  isUserAndRoleAnalyticsFailed: false,
  userAndRoleAnalyticsData: {
    totalUser: 0,
    totalRole: 0,
    totalGroup: 0,
    analyticsData: []
  },
  userAndRoleAnalyticsErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isUserAnalyticsLoading: false,
  isUserAnalyticsSuccess: false,
  isUserAnalyticsFailed: false,
  userAnalyticsData: {
    analyticsData: []
  },
  userAnalyticsErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isLocationAnalyticsLoading: false,
  isLocationAnalyticsSuccess: false,
  isLocationAnalyticsFailed: false,
  locationAnalyticsData: {
    totalSchool: 0,
    totalArea: 0,
    totalDistrict: 0,
    analyticsData: []
  },
  locationAnalyticsErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isFlowsAndFormsAnalyticsLoading: false,
  isFlowsAndFormsAnalyticsSuccess: false,
  isFlowsAndFormsAnalyticsFailed: false,
  flowsAndFormsAnalyticsData: {
    totalForms: 0,
    totalResponse: 0,
    totalAverageResponseTime: 0,
    analyticsData: []
  },
  flowsAndFormsAnalyticsErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isContentAnalyticsLoading: false,
  isContentAnalyticsSuccess: false,
  isContentAnalyticsFailed: false,
  contentAnalyticsData: {
    totalLikesCount: 0,
    totalDownloadsCount: 0,
    totalViewsCount: 0,
    totalCommentsCount: 0,
    totalSharesCount: 0,
    analyticsData: []
  },
  contentAnalyticsErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isContentAnalyticsLogsLoading: false,
  isContentAnalyticsLogsSuccess: false,
  isContentAnalyticsLogsFailed: false,
  contentAnalyticsLogData: {
    logData: [],
    totalCount: 0
  },
  contentAnalyticsLogErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isFlowsAndFormsAnalyticsDetailLoading: false,
  isFlowsAndFormsAnalyticsDetailSuccess: false,
  isFlowsAndFormsAnalyticsDetailFailed: false,
  flowsAndFormsAnalyticsDetailData: null,
  flowsAndFormsAnalyticsDetailErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isContentCreatedByDataLoading: false,
  isContentCreatedByDataSuccess: false,
  isContentCreatedByDataFailed: false,
  contentCreatedByData: [],
  contentCreatedByDataErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isTeacherObservationsAnalyticsLoading: false,
  isTeacherObservationsAnalyticsSuccess: false,
  isTeacherObservationsAnalyticsFailed: false,

  isTeacherObservationsRubricAnalyticsLoading: false,
  isTeacherObservationsRubricAnalyticsSuccess: false,
  isTeacherObservationsRubricAnalyticsFailed: false,

  isTeacherObservationsUserAnalyticsLoading: false,
  isTeacherObservationsUserAnalyticsSuccess: false,
  isTeacherObservationsUserAnalyticsFailed: false,
  teacherObservationsAnalyticsData: {
    totalObservationCount: 0,
    totalIndicatorCount: 0,
    totalObservationAverage: 0,
    rubricAnalyticsData: [],
    userAnalyticsData: []
  },
  teacherObservationsAnalyticsErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isMetaDataStateLoading: false,
  isMetaDataStateSuccess: false,
  isMetaDataStateFailed: false,
  metaDataState: [],
  metaDataStateErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isMetaDataDistrictLoading: false,
  isMetaDataDistrictSuccess: false,
  isMetaDataDistrictFailed: false,
  metaDataDistrict: [],
  metaDataDistrictErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isMetaDataAreaLoading: false,
  isMetaDataAreaSuccess: false,
  isMetaDataAreaFailed: false,
  metaDataArea: [],
  metaDataAreaErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isMetaDataSchoolLoading: false,
  isMetaDataSchoolSuccess: false,
  isMetaDataSchoolFailed: false,
  metaDataSchool: [],
  metaDataSchoolErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isObservationCardDataLoading: false,
  isObservationCardDataSuccess: false,
  isObservationCardDataFailed: false,
  observationCardData: [],
  observationCardErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isObservationDetailLoading: false,
  isObservationDetailSuccess: false,
  isObservationDetailFailed: false,
  observationDetail: null,
  observationDetailErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isObservationsLoading: false,
  isObservationsSuccess: false,
  isObservationsFailed: false,
  observationData: { totalCount: 0, observation: [] },
  observationErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isGetContentAnalyticsTableListLoading: false,
  isGetContentAnalyticsTableListSuccess: false,
  isGetContentAnalyticsTableListFailed: false,
  analyticsContentList: {
    allCount: 0,
    contentList: []
  },
  getContentAnalyticsTableListErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  },

  isDashboardMetricsLoading: false,
  isDashboardMetricsSuccess: false,
  isDashboardMetricsFailed: false,
  dashboardMetrics: {
    teacherCount: 0,
    facilitatorCount: 0,
    schoolCount: 0,
    contentViews: 0,
    contentEngagement: 0,
    resourceCount: 0,
    totalUsers: 0,
    publishedContentCount: 0
  },
  dashboardMetricsErrorContainer: {
    error: false,
    errorMessage: 'Internal Server Error',
    description: 'Something Went Wrong',
    statusCode: 0
  }
};

const normalizeMetricCount = value => {
  if (Array.isArray(value)) {
    return Number(value[0]) || 0;
  }
  return Number(value) || 0;
};

const mapDashboardSummaryResponse = dataList => {
  const contentMetricCount = normalizeMetricCount(dataList.contentMetricCount);

  return {
    teacherCount: normalizeMetricCount(dataList.teacherCount),
    facilitatorCount: normalizeMetricCount(dataList.facilitatorCount),
    schoolCount: normalizeMetricCount(dataList.schoolCount),
    resourceCount: normalizeMetricCount(dataList.resourceMetricCount),
    totalUsers: normalizeMetricCount(dataList.totalUserCount),
    publishedContentCount: contentMetricCount,
    contentViews: contentMetricCount,
    contentEngagement: 0
  };
};

const fetchDashboardMetricsFallback = async () => {
  const [userCountResult, locationResult, contentResult, resourcesResult] =
    await Promise.allSettled([
      api.get('analytics/userCountAnalytics'),
      api.post('analytics/countOfStateAndAreaAndSchool', {}),
      api.post('content/countOfContentsData', {}),
      api.get('resources/getAllContentByData')
    ]);

  const userDataList =
    userCountResult.status === 'fulfilled'
      ? userCountResult.value.data?.payload?.dataList || {}
      : {};
  const locationDataList =
    locationResult.status === 'fulfilled'
      ? locationResult.value.data?.payload?.dataList || {}
      : {};
  const contentDataList =
    contentResult.status === 'fulfilled'
      ? contentResult.value.data?.payload?.dataList || {}
      : {};
  const resourcesPayload =
    resourcesResult.status === 'fulfilled'
      ? resourcesResult.value.data?.payload
      : null;

  const publishedContentCount = normalizeMetricCount(
    contentDataList.totalContentsCount ??
      contentDataList.contentMetricCount ??
      contentDataList.totalContentCount
  );

  return {
    teacherCount: 0,
    facilitatorCount: 0,
    schoolCount: normalizeMetricCount(locationDataList.totalSchoolCount),
    resourceCount: Array.isArray(resourcesPayload)
      ? resourcesPayload.length
      : normalizeMetricCount(
          resourcesPayload?.resourceMetricCount ??
            resourcesPayload?.totalResourceCount
        ),
    totalUsers: normalizeMetricCount(userDataList.totalUserCount),
    publishedContentCount,
    contentViews: normalizeMetricCount(contentDataList.totalViewsCount),
    contentEngagement: 0
  };
};

export const revertUserAndRoleAnalytics = createAction(
  'REVERT_USER_AND_ROLE_ANALYTICS_DATA'
);

export const revertLocationAnalytics = createAction(
  'REVERT_LOCATION_ANALYTICS_DATA'
);

export const revertFlowsAndFormsAnalytics = createAction(
  'REVERT_FLOWS_AND_FORMS_ANALYTICS_DATA'
);

export const revertTeacherObservationsAnalytics = createAction(
  'REVERT_TEACHER_OBSERVATIONS_ANALYTICS_DATA'
);

export const getUserAndRoleAnalytics = createAsyncThunk(
  'analytics/getUserAndRoleAnalytics',
  async (payload, { rejectWithValue }) => {
    try {
      let response = await api.post(
        `analytics/userAndRoleCountAnalytics`,
        payload
      );
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getUserAnalytics = createAsyncThunk(
  'analytics/getUserAnalytics',
  async (payload, { rejectWithValue }) => {
    try {
      let response = await api.post(`analytics/userCountAnalytics`, payload);
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getLocationAnalytics = createAsyncThunk(
  'analytics/getLocationAnalytics',
  async (payload, { rejectWithValue }) => {
    try {
      let response = await api.post(
        `analytics/countOfStateAndAreaAndSchool`,
        payload
      );
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getFlowsAndFormsAnalytics = createAsyncThunk(
  'analytics/getFlowsAndFormsAnalytics',
  async (payload, { rejectWithValue }) => {
    try {
      let response = await api.post(
        `analytics/countOfFormAndResponse`,
        payload
      );
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getContentAnalytics = createAsyncThunk(
  'analytics/getContentAnalytics',
  async (payload, { rejectWithValue }) => {
    try {
      let response = await api.post(`content/countOfContentsData`, payload);
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getContentAnalyticsLogsById = createAsyncThunk(
  'analytics/getContentAnalyticsLogsById',
  async (payload, { rejectWithValue }) => {
    try {
      let response = await api.post(
        `resources/getContentAnalyticsLogs`,
        payload
      );
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getFlowsAndFormsAnalyticsDetail = createAsyncThunk(
  'analytics/getFlowsAndFormsAnalyticsDetail',
  async ({ formId, flowId }, { rejectWithValue }) => {
    try {
      let response = await api.get(
        `analytics/formAnalytics/${formId}?flowId=${flowId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getTeacherObservationsCount = createAsyncThunk(
  'analytics/getTeacherObservationsCount',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/analytics/teacherObservation`);

      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getTeacherObservationsRubric = createAsyncThunk(
  'analytics/getTeacherObservationsRubric',
  async (payload, { rejectWithValue }) => {
    try {
      let response = await api.post(
        `analytics/teacherObservation/rubric`,
        payload
      );
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getTeacherObservationsUserAnalytics = createAsyncThunk(
  'analytics/getTeacherObservationsUserAnalytics',
  async (payload, { rejectWithValue }) => {
    try {
      let response = await api.post(
        `analytics/teacherObservation/observation`,
        payload
      );
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getMetaDataState = createAsyncThunk(
  'analytics/getMetaDataState',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiNoAuth.post(
        '/analytics/metadata/states',
        payload
      );
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getMetaDataArea = createAsyncThunk(
  'analytics/getMetaDataArea',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiNoAuth.post(
        '/analytics/metadata/areas',
        payload
      );
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getMetaDataDistrict = createAsyncThunk(
  'analytics/getMetaDataDistrict',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiNoAuth.post(
        '/analytics/metadata/districts',
        payload
      );
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getMetaDataSchool = createAsyncThunk(
  'analytics/getMetaDataSchool',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiNoAuth.post(
        '/analytics/metadata/schools',
        payload
      );
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getObservationByUserId = createAsyncThunk(
  'analytics/getObservationByUserId',
  async (payload, { rejectWithValue }) => {
    try {
      let response = await api.post(
        `analytics/teacherObservation/observationByUserId`,
        payload
      );
      return response.data?.payload;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getObservationsAnalyticsDetail = createAsyncThunk(
  'analytics/getObservationsAnalyticsDetail',
  async (observationId, { rejectWithValue }) => {
    try {
      // const response = await api.get(`teachers/observation/${observationId}`);
      const response = await api.get(
        `analytics/metadata/observation/${observationId}`
      );
      return response.data.payload || null;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getAnalyticsObservations = createAsyncThunk(
  'observation/getAnalyticsObservations',
  async ({ payload }, { rejectWithValue, getState }) => {
    try {
      let response;
      response = await api.post(
        `analytics/metadata/observation/getAllObservation/search/${getState().auth.authData.userId}`,
        payload
      );

      return response.data.payload || initial.observationData;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getUserAndRoleAnalyticsCount = createAsyncThunk(
  'analytics/getUserAndRoleAnalyticsCount',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`analytics/userCountAnalytics`);
      return response.data.payload || null;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getDashboardMetrics = createAsyncThunk(
  'analytics/getDashboardMetrics',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('analytics/dashboardSummary');
      return mapDashboardSummaryResponse(
        response.data?.payload?.dataList || {}
      );
    } catch (error) {
      const status = error.response?.status;

      if (status === 401 || status === 404) {
        try {
          return await fetchDashboardMetricsFallback();
        } catch (fallbackError) {
          return rejectWithValue(fallbackError.response?.data?.error);
        }
      }

      return rejectWithValue(error.response?.data?.error);
    }
  }
);

export const getContentCreatedByData = createAsyncThunk(
  'analytics/getContentCreatedByData',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`resources/getAllContentByData`);
      return response.data.payload || null;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const getContentAnalyticsTableList = createAsyncThunk(
  'content/getContentAnalyticsTableList',
  async ({ payload, search }, { rejectWithValue }) => {
    try {
      //
      let response;

      if (search == '' || search == null) {
        response = await api.post(
          `content/getAllContentAnalyticsData`,
          payload
        );
      } else {
        response = await api.post(
          `content/getAllContentAnalyticsData?searchCriteria=${search}`,
          payload
        );
      }
      return response.data?.payload || initial.usersData;
    } catch (error) {
      return rejectWithValue(error.response.data?.error);
    }
  }
);

export const analyticsSlice = createSlice({
  name: 'analytics',
  initialState: initial,
  extraReducers: builder => {
    builder
      .addCase(revertUserAndRoleAnalytics, state => {
        state.isUserAnalyticsLoading = initial.isUserAnalyticsLoading;
        state.isUserAnalyticsSuccess = initial.isUserAnalyticsSuccess;
        state.isUserAnalyticsFailed = initial.isUserAnalyticsFailed;
        state.userAnalyticsData = initial.userAnalyticsData;
        state.userAndRoleAnalyticsErrorContainer =
          initial.userAndRoleAnalyticsErrorContainer;

        state.isUserAndRoleAnalyticsLoading =
          initial.isUserAndRoleAnalyticsLoading;
        state.isUserAndRoleAnalyticsSuccess =
          initial.isUserAndRoleAnalyticsSuccess;
        state.isUserAndRoleAnalyticsFailed =
          initial.isUserAndRoleAnalyticsFailed;
        state.userAnalyticsErrorContainer = initial.userAnalyticsErrorContainer;
      })
      .addCase(revertLocationAnalytics, state => {
        state.isLocationAnalyticsLoading = initial.isLocationAnalyticsLoading;
        state.isLocationAnalyticsSuccess = initial.isLocationAnalyticsSuccess;
        state.isLocationAnalyticsFailed = initial.isLocationAnalyticsFailed;
        state.locationAnalyticsData = initial.locationAnalyticsData;
        state.locationAnalyticsErrorContainer =
          initial.locationAnalyticsErrorContainer;
      })

      .addCase(revertFlowsAndFormsAnalytics, state => {
        state.isFlowsAndFormsAnalyticsLoading =
          initial.isFlowsAndFormsAnalyticsLoading;
        state.isFlowsAndFormsAnalyticsSuccess =
          initial.isFlowsAndFormsAnalyticsSuccess;
        state.isFlowsAndFormsAnalyticsFailed =
          initial.isFlowsAndFormsAnalyticsFailed;
        state.flowsAndFormsAnalyticsData = initial.flowsAndFormsAnalyticsData;
        state.flowsAndFormsAnalyticsErrorContainer =
          initial.flowsAndFormsAnalyticsErrorContainer;
      })

      .addCase(revertTeacherObservationsAnalytics, state => {
        state.isTeacherObservationsAnalyticsLoading =
          initial.isTeacherObservationsAnalyticsLoading;
        state.isTeacherObservationsAnalyticsSuccess =
          initial.isTeacherObservationsAnalyticsSuccess;
        state.isTeacherObservationsAnalyticsFailed =
          initial.isTeacherObservationsAnalyticsFailed;
        state.teacherObservationsAnalyticsData =
          initial.teacherObservationsAnalyticsData;
        state.teacherObservationsAnalyticsErrorContainer =
          initial.teacherObservationsAnalyticsErrorContainer;
      })

      .addCase(getUserAndRoleAnalytics.pending, state => {
        state.isUserAndRoleAnalyticsLoading = true;
        state.isUserAndRoleAnalyticsSuccess = false;
        state.isUserAndRoleAnalyticsFailed = false;
        state.userAndRoleAnalyticsData = {
          ...state.userAndRoleAnalyticsData,
          analyticsData: []
        };
        state.userAndRoleAnalyticsErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getUserAndRoleAnalytics.fulfilled, (state, action) => {
        state.isUserAndRoleAnalyticsLoading = false;
        state.isUserAndRoleAnalyticsSuccess = true;
        state.isUserAndRoleAnalyticsFailed = false;
        state.userAndRoleAnalyticsData = {
          ...state.userAndRoleAnalyticsData,
          analyticsData: action.payload?.dataList?.UserAndRole || []
        };
      })
      .addCase(getUserAndRoleAnalytics.rejected, (state, action) => {
        state.isUserAndRoleAnalyticsLoading = false;
        state.isUserAndRoleAnalyticsSuccess = false;
        state.isUserAndRoleAnalyticsFailed = true;
        state.userAndRoleAnalyticsData = { ...state, analyticsData: [] };
        state.userAndRoleAnalyticsErrorContainer = {
          ...state.userAndRoleAnalyticsErrorContainer,
          ...action.payload
        };
      })

      .addCase(getUserAnalytics.pending, state => {
        state.isUserAnalyticsLoading = true;
        state.isUserAnalyticsSuccess = false;
        state.isUserAnalyticsFailed = false;
        state.userAnalyticsData = initial.userAnalyticsData;
        state.userAnalyticsErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getUserAnalytics.fulfilled, (state, action) => {
        state.isUserAnalyticsLoading = false;
        state.isUserAnalyticsSuccess = true;
        state.isUserAnalyticsFailed = false;
        state.userAnalyticsData = {
          analyticsData: action.payload?.dataList?.userCount || []
        };
      })
      .addCase(getUserAnalytics.rejected, (state, action) => {
        state.isUserAndRoleAnalyticsLoading = false;
        state.isUserAndRoleAnalyticsSuccess = false;
        state.isUserAndRoleAnalyticsFailed = true;
        state.userAnalyticsData = initial.userAnalyticsData;
        state.userAnalyticsErrorContainer = {
          ...state.userAnalyticsErrorContainer,
          ...action.payload
        };
      })

      .addCase(getLocationAnalytics.pending, state => {
        state.isLocationAnalyticsLoading = true;
        state.isLocationAnalyticsSuccess = false;
        state.isLocationAnalyticsFailed = false;
        state.locationAnalyticsData = initial.userAndRoleAnalyticsData;
        state.locationAnalyticsErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getLocationAnalytics.fulfilled, (state, action) => {
        state.isLocationAnalyticsLoading = false;
        state.isLocationAnalyticsSuccess = true;
        state.isLocationAnalyticsFailed = false;
        state.locationAnalyticsData = {
          totalArea: action.payload?.dataList?.totalAreaCount || 0,
          totalDistrict: action.payload?.dataList?.totalDistrictCount || 0,
          totalSchool: action.payload?.dataList?.totalSchoolCount || 0,
          analyticsData: action.payload?.dataList?.locationAnalytics || []
        };
      })
      .addCase(getLocationAnalytics.rejected, (state, action) => {
        state.isLocationAnalyticsLoading = false;
        state.isLocationAnalyticsSuccess = false;
        state.isLocationAnalyticsFailed = true;
        state.locationAnalyticsData = initial.locationAnalyticsData;
        state.locationAnalyticsErrorContainer = {
          ...state.locationAnalyticsErrorContainer,
          ...action.payload
        };
      })

      .addCase(getFlowsAndFormsAnalytics.pending, state => {
        state.isFlowsAndFormsAnalyticsLoading = true;
        state.isFlowsAndFormsAnalyticsSuccess = false;
        state.isFlowsAndFormsAnalyticsFailed = false;
        state.flowsAndFormsAnalyticsData = initial.flowsAndFormsAnalyticsData;
        state.flowsAndFormsAnalyticsErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getFlowsAndFormsAnalytics.fulfilled, (state, action) => {
        state.isFlowsAndFormsAnalyticsLoading = false;
        state.isFlowsAndFormsAnalyticsSuccess = true;
        state.isFlowsAndFormsAnalyticsFailed = false;
        state.flowsAndFormsAnalyticsData = {
          totalForms:
            action.payload?.dataList?.['totalForm count']?.[0] ||
            action.payload?.dataList?.['totalFormCount']?.[0] ||
            0,
          totalResponse: action.payload?.dataList?.totalResponseCount?.[0] || 0,
          totalAverageResponseTime:
            action.payload?.dataList?.totalResponseAverageTime?.[0] || 0,
          analyticsData:
            action.payload?.dataList?.['Form Analytics'] ||
            action.payload?.dataList?.formAnalytics ||
            []
        };
      })
      .addCase(getFlowsAndFormsAnalytics.rejected, (state, action) => {
        state.isFlowsAndFormsAnalyticsLoading = false;
        state.isFlowsAndFormsAnalyticsSuccess = false;
        state.isFlowsAndFormsAnalyticsFailed = true;
        state.flowsAndFormsAnalyticsData = initial.locationAnalyticsData;
        state.flowsAndFormsAnalyticsErrorContainer = {
          ...state.flowsAndFormsAnalyticsErrorContainer,
          ...action.payload
        };
      })

      .addCase(getContentAnalytics.pending, state => {
        state.isContentAnalyticsLoading = true;
        state.isContentAnalyticsSuccess = false;
        state.isContentAnalyticsFailed = false;
        state.contentAnalyticsData = initial.contentAnalyticsData;
        state.contentAnalyticsErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getContentAnalytics.fulfilled, (state, action) => {
        state.isContentAnalyticsLoading = false;
        state.isContentAnalyticsSuccess = true;
        state.isContentAnalyticsFailed = false;
        state.contentAnalyticsData = {
          totalLikesCount:
            action.payload?.dataList?.['totalLikesCount']?.[0] || 0,
          totalDownloadsCount:
            action.payload?.dataList?.totalDownloadsCount?.[0] || 0,
          totalViewsCount: action.payload?.dataList?.totalViewsCount?.[0] || 0,
          totalCommentsCount:
            action.payload?.dataList?.totalCommentsCount?.[0] || 0,
          totalSharesCount:
            action.payload?.dataList?.totalSharesCount?.[0] || 0,
          analyticsData: action.payload?.dataList?.contentAnalytics || []
        };
      })
      .addCase(getContentAnalytics.rejected, (state, action) => {
        state.isContentAnalyticsLoading = false;
        state.isContentAnalyticsSuccess = false;
        state.isContentAnalyticsFailed = true;
        state.contentAnalyticsData = initial.contentAnalyticsData;
        state.contentAnalyticsErrorContainer = {
          ...state.contentAnalyticsErrorContainer,
          ...action.payload
        };
      })

      .addCase(getContentAnalyticsLogsById.pending, state => {
        state.isContentAnalyticsLogsLoading = true;
        state.isContentAnalyticsLogsSuccess = false;
        state.isContentAnalyticsLogsFailed = false;
        state.contentAnalyticsLogData = initial.contentAnalyticsLogData;
        state.contentAnalyticsLogErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getContentAnalyticsLogsById.fulfilled, (state, action) => {
        state.isContentAnalyticsLogsLoading = false;
        state.isContentAnalyticsLogsSuccess = true;
        state.isContentAnalyticsLogsFailed = false;
        state.contentAnalyticsLogData = {
          logData: action.payload?.dataList || [],
          totalCount: action.payload?.totalCount || 0
        };
      })
      .addCase(getContentAnalyticsLogsById.rejected, (state, action) => {
        state.isContentAnalyticsLogsLoading = false;
        state.isContentAnalyticsLogsSuccess = false;
        state.isContentAnalyticsLogsFailed = true;
        state.contentAnalyticsLogData = initial.contentAnalyticsLogData;
        state.contentAnalyticsLogErrorContainer = {
          ...state.contentAnalyticsLogErrorContainer,
          ...action.payload
        };
      })

      .addCase(getFlowsAndFormsAnalyticsDetail.pending, state => {
        state.isFlowsAndFormsAnalyticsDetailLoading = true;
        state.isFlowsAndFormsAnalyticsDetailSuccess = false;
        state.isFlowsAndFormsAnalyticsDetailFailed = false;
        state.flowsAndFormsAnalyticsDetailData =
          initial.flowsAndFormsAnalyticsDetailData;
        state.flowsAndFormsAnalyticsDetailErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getFlowsAndFormsAnalyticsDetail.fulfilled, (state, action) => {
        state.isFlowsAndFormsAnalyticsDetailLoading = false;
        state.isFlowsAndFormsAnalyticsDetailSuccess = true;
        state.isFlowsAndFormsAnalyticsDetailFailed = false;
        state.flowsAndFormsAnalyticsDetailData = action.payload?.payload;
      })
      .addCase(getFlowsAndFormsAnalyticsDetail.rejected, (state, action) => {
        state.isFlowsAndFormsAnalyticsDetailLoading = false;
        state.isFlowsAndFormsAnalyticsDetailSuccess = false;
        state.isFlowsAndFormsAnalyticsDetailFailed = true;
        state.flowsAndFormsAnalyticsDetailData =
          initial.flowsAndFormsAnalyticsDetailData;
        state.flowsAndFormsAnalyticsDetailErrorContainer = {
          ...state.flowsAndFormsAnalyticsDetailErrorContainer,
          ...action.payload
        };
      })

      .addCase(getContentCreatedByData.pending, state => {
        state.isContentCreatedByDataLoading = true;
        state.isContentCreatedByDataSuccess = false;
        state.isContentCreatedByDataFailed = false;
        state.contentCreatedByData = initial.contentCreatedByData;
        state.contentCreatedByDataErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getContentCreatedByData.fulfilled, (state, action) => {
        state.isContentCreatedByDataLoading = false;
        state.isContentCreatedByDataSuccess = true;
        state.isContentCreatedByDataFailed = false;
        state.contentCreatedByData = action.payload;
      })
      .addCase(getContentCreatedByData.rejected, (state, action) => {
        state.isContentCreatedByDataLoading = false;
        state.isContentCreatedByDataSuccess = false;
        state.isContentCreatedByDataFailed = true;
        state.contentCreatedByData = initial.contentCreatedByData;
        state.contentCreatedByDataErrorContainer = {
          ...state.contentCreatedByDataErrorContainer,
          ...action.payload
        };
      })

      .addCase(getTeacherObservationsCount.pending, state => {
        state.isTeacherObservationsAnalyticsLoading = true;
        state.isTeacherObservationsAnalyticsSuccess = false;
        state.isTeacherObservationsAnalyticsFailed = false;
        state.teacherObservationsAnalyticsData =
          initial.teacherObservationsAnalyticsData;
        state.teacherObservationsAnalyticsErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getTeacherObservationsCount.fulfilled, (state, action) => {
        state.isTeacherObservationsAnalyticsLoading = false;
        state.isTeacherObservationsAnalyticsSuccess = true;
        state.isTeacherObservationsAnalyticsFailed = false;
        state.teacherObservationsAnalyticsData = {
          ...state.teacherObservationsAnalyticsData,
          totalObservationAverage:
            action.payload?.dataList?.totalObservationAverage || 0,
          totalIndicatorCount:
            action.payload?.dataList?.totalIndicatorCount || 0,
          totalObservationCount:
            action.payload?.dataList?.totalObservationCount || 0
        };
      })
      .addCase(getTeacherObservationsCount.rejected, (state, action) => {
        state.isTeacherObservationsAnalyticsLoading = false;
        state.isTeacherObservationsAnalyticsSuccess = false;
        state.isTeacherObservationsAnalyticsFailed = true;
        state.teacherObservationsAnalyticsData =
          initial.teacherObservationsAnalyticsData;
        state.teacherObservationsAnalyticsErrorContainer = {
          ...state.teacherObservationsAnalyticsErrorContainer,
          ...action.payload
        };
      })

      .addCase(getTeacherObservationsRubric.pending, state => {
        state.isTeacherObservationsRubricAnalyticsLoading = true;
        state.isTeacherObservationsRubricAnalyticsSuccess = false;
        state.isTeacherObservationsRubricAnalyticsFailed = false;
        state.teacherObservationsAnalyticsData = {
          ...state.teacherObservationsAnalyticsData,
          rubricAnalyticsData: []
        };
        state.teacherObservationsAnalyticsErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getTeacherObservationsRubric.fulfilled, (state, action) => {
        state.isTeacherObservationsRubricAnalyticsLoading = false;
        state.isTeacherObservationsRubricAnalyticsSuccess = true;
        state.isTeacherObservationsRubricAnalyticsFailed = false;
        state.teacherObservationsAnalyticsData = {
          ...state.teacherObservationsAnalyticsData,
          rubricAnalyticsData: action.payload?.dataList?.indAverageRating || []
        };
      })
      .addCase(getTeacherObservationsRubric.rejected, (state, action) => {
        state.isTeacherObservationsRubricAnalyticsLoading = false;
        state.isTeacherObservationsRubricAnalyticsSuccess = false;
        state.isTeacherObservationsRubricAnalyticsFailed = true;
        state.teacherObservationsAnalyticsData = {
          ...state.teacherObservationsAnalyticsData,
          rubricAnalyticsData: []
        };
        state.teacherObservationsAnalyticsErrorContainer = {
          ...state.teacherObservationsAnalyticsErrorContainer,
          ...action.payload
        };
      })

      .addCase(getTeacherObservationsUserAnalytics.pending, state => {
        state.isTeacherObservationsUserAnalyticsLoading = true;
        state.isTeacherObservationsUserAnalyticsSuccess = false;
        state.isTeacherObservationsUserAnalyticsFailed = false;
        state.teacherObservationsAnalyticsData = {
          ...state.teacherObservationsAnalyticsData,
          userAnalyticsData: []
        };
        state.teacherObservationsAnalyticsErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(
        getTeacherObservationsUserAnalytics.fulfilled,
        (state, action) => {
          state.isTeacherObservationsUserAnalyticsLoading = false;
          state.isTeacherObservationsUserAnalyticsSuccess = true;
          state.isTeacherObservationsUserAnalyticsFailed = false;
          state.teacherObservationsAnalyticsData = {
            ...state.teacherObservationsAnalyticsData,
            userAnalyticsData:
              action.payload?.dataList?.observationAndIndicatorCount || []
          };
        }
      )
      .addCase(
        getTeacherObservationsUserAnalytics.rejected,
        (state, action) => {
          state.isTeacherObservationsUserAnalyticsLoading = false;
          state.isTeacherObservationsUserAnalyticsSuccess = false;
          state.isTeacherObservationsUserAnalyticsFailed = true;
          state.teacherObservationsAnalyticsData = {
            ...state.teacherObservationsAnalyticsData,
            rubricAnalyticsData: []
          };
          state.teacherObservationsAnalyticsErrorContainer = {
            ...state.teacherObservationsAnalyticsErrorContainer,
            ...action.payload
          };
        }
      )

      .addCase(getMetaDataState.pending, state => {
        state.isMetaDataStateLoading = true;
        state.isMetaDataStateSuccess = false;
        state.isMetaDataStateFailed = false;
        state.metaDataState = [];
        state.metaDataStateErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getMetaDataState.fulfilled, (state, action) => {
        state.isMetaDataStateLoading = false;
        state.isMetaDataStateSuccess = true;
        state.isMetaDataStateFailed = false;
        state.metaDataState = action.payload?.dataList;
      })
      .addCase(getMetaDataState.rejected, (state, action) => {
        state.isMetaDataStateLoading = true;
        state.isMetaDataStateSuccess = false;
        state.isMetaDataStateFailed = false;
        state.metaDataState = [];
        state.metaDataStateErrorContainer = {
          ...state.metaDataStateErrorContainer,
          ...action.payload
        };
      })

      .addCase(getMetaDataDistrict.pending, state => {
        state.isMetaDataDistrictLoading = true;
        state.isMetaDataDistrictSuccess = false;
        state.isMetaDataDistrictFailed = false;
        state.metaDataDistrict = [];
        state.metaDataDistrictErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getMetaDataDistrict.fulfilled, (state, action) => {
        state.isMetaDataDistrictLoading = false;
        state.isMetaDataDistrictSuccess = true;
        state.isMetaDataDistrictFailed = false;
        state.metaDataDistrict = action.payload?.dataList;
      })
      .addCase(getMetaDataDistrict.rejected, (state, action) => {
        state.isMetaDataDistrictLoading = true;
        state.isMetaDataDistrictSuccess = false;
        state.isMetaDataDistrictFailed = false;
        state.metaDataDistrict = [];
        state.metaDataDistrictErrorContainer = {
          ...state.metaDataDistrictErrorContainer,
          ...action.payload
        };
      })

      .addCase(getMetaDataArea.pending, state => {
        state.isMetaDataAreaLoading = true;
        state.isMetaDataAreaSuccess = false;
        state.isMetaDataAreaFailed = false;
        state.metaDataArea = [];
        state.metaDataAreaErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getMetaDataArea.fulfilled, (state, action) => {
        state.isMetaDataAreaLoading = false;
        state.isMetaDataAreaSuccess = true;
        state.isMetaDataAreaFailed = false;
        state.metaDataArea = action.payload?.dataList;
      })
      .addCase(getMetaDataArea.rejected, (state, action) => {
        state.isMetaDataAreaLoading = true;
        state.isMetaDataAreaSuccess = false;
        state.isMetaDataAreaFailed = false;
        state.metaDataArea = [];
        state.metaDataAreaErrorContainer = {
          ...state.metaDataAreaErrorContainer,
          ...action.payload
        };
      })

      .addCase(getMetaDataSchool.pending, state => {
        state.isMetaDataSchoolLoading = true;
        state.isMetaDataSchoolSuccess = false;
        state.isMetaDataSchoolFailed = false;
        state.metaDataSchool = [];
        state.metaDataSchoolErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getMetaDataSchool.fulfilled, (state, action) => {
        state.isMetaDataSchoolLoading = false;
        state.isMetaDataSchoolSuccess = true;
        state.isMetaDataSchoolFailed = false;
        state.metaDataSchool = action.payload?.dataList;
      })
      .addCase(getMetaDataSchool.rejected, (state, action) => {
        state.isMetaDataSchoolLoading = true;
        state.isMetaDataSchoolSuccess = false;
        state.isMetaDataSchoolFailed = false;
        state.metaDataSchool = [];
        state.metaDataSchoolErrorContainer = {
          ...state.metaDataSchoolErrorContainer,
          ...action.payload
        };
      })

      .addCase(getObservationsAnalyticsDetail.pending, state => {
        state.isObservationDetailLoading = true;
        state.isObservationDetailSuccess = false;
        state.isObservationDetailFailed = false;
        state.observationDetail = null;
        state.observationDetailErrorContainer =
          initial.observationDetailErrorContainer;
      })
      .addCase(getObservationsAnalyticsDetail.fulfilled, (state, action) => {
        state.isObservationDetailLoading = false;
        state.isObservationDetailSuccess = true;
        state.isObservationDetailFailed = false;
        state.observationDetail = action.payload;
        state.observationDetailErrorContainer =
          initial.observationDetailErrorContainer;
      })
      .addCase(getObservationsAnalyticsDetail.rejected, (state, action) => {
        state.isObservationDetailLoading = false;
        state.isObservationDetailSuccess = false;
        state.isObservationDetailFailed = true;
        state.observationDetailErrorContainer = {
          ...state.observationDetailErrorContainer,
          ...action.payload
        };
      })

      .addCase(getAnalyticsObservations.pending, state => {
        state.isObservationsLoading = true;
        state.isObservationsSuccess = false;
        state.isObservationsFailed = false;
        state.observationData = initial.observationData;
        state.observationErrorContainer = initial.observationErrorContainer;
      })
      .addCase(getAnalyticsObservations.fulfilled, (state, action) => {
        state.isObservationsLoading = false;
        state.isObservationsSuccess = true;
        state.isObservationsFailed = false;
        state.observationData = {
          totalCount: action.payload.totalCount,
          observation: action.payload.dataList
        };
        state.observationErrorContainer = initial.observationErrorContainer;
      })
      .addCase(getAnalyticsObservations.rejected, (state, action) => {
        state.isObservationsLoading = false;
        state.isObservationsSuccess = false;
        state.isObservationsFailed = true;
        state.observationData = initial.observationData;
        state.observationErrorContainer = {
          ...state.observationErrorContainer,
          ...action.payload
        };
      })

      .addCase(getObservationByUserId.pending, state => {
        state.isObservationCardDataLoading = true;
        state.isObservationCardDataSuccess = false;
        state.isObservationCardDataFailed = false;
        state.observationCardData = null;
        state.observationDetailErrorContainer =
          initial.observationDetailErrorContainer;
      })
      .addCase(getObservationByUserId.fulfilled, (state, action) => {
        state.isObservationCardDataLoading = false;
        state.isObservationCardDataSuccess = true;
        state.isObservationCardDataFailed = false;
        state.observationCardData =
          action.payload?.dataList?.observationAndAverageCount || [];
        state.observationDetailErrorContainer =
          initial.observationDetailErrorContainer;
      })
      .addCase(getObservationByUserId.rejected, (state, action) => {
        state.isObservationCardDataLoading = false;
        state.isObservationCardDataSuccess = false;
        state.isObservationCardDataFailed = true;
        state.observationDetailErrorContainer = {
          ...state.observationDetailErrorContainer,
          ...action.payload
        };
      })

      .addCase(getUserAndRoleAnalyticsCount.pending, state => {
        state.userAndRoleAnalyticsData = {
          ...state.userAndRoleAnalyticsData,
          totalUser: 0,
          totalGroup: 0,
          totalRole: 0
        };
      })
      .addCase(getUserAndRoleAnalyticsCount.fulfilled, (state, action) => {
        state.userAndRoleAnalyticsData = {
          ...state.userAndRoleAnalyticsData,
          totalUser: action?.payload?.dataList['totalUserCount'],
          totalGroup: action?.payload?.dataList['totalUserGroupCount'],
          totalRole: action?.payload?.dataList['totalRoleCount']
        };
      })
      .addCase(getUserAndRoleAnalyticsCount.rejected, (state, action) => {
        state.isObservationCardDataLoading = false;
        state.isObservationCardDataSuccess = false;
        state.isObservationCardDataFailed = true;
        state.observationDetailErrorContainer = {
          ...state.observationDetailErrorContainer,
          ...action.payload
        };
      })

      .addCase(getContentAnalyticsTableList.pending, state => {
        state.isGetContentAnalyticsTableListLoading = true;
        state.isGetContentAnalyticsTableListSuccess = false;
        state.isGetContentAnalyticsTableListFailed = false;
        state.getContentAnalyticsTableListErrorContainer = {
          error: false,
          errorMessage: '',
          description: '',
          statusCode: 0
        };
      })
      .addCase(getContentAnalyticsTableList.fulfilled, (state, action) => {
        state.isGetContentAnalyticsTableListLoading = false;
        state.isGetContentAnalyticsTableListSuccess = true;
        state.analyticsContentList = {
          ...state.analyticsContentList,
          contentList: action.payload?.dataList,
          allCount: action.payload?.allCount
        };
      })
      .addCase(getContentAnalyticsTableList.rejected, (state, action) => {
        state.isGetContentAnalyticsTableListLoading = false;
        state.isGetContentAnalyticsTableListFailed = true;
        state.analyticsContentList = initial.analyticsContentList;
        state.getContentAnalyticsTableListErrorContainer = {
          ...state.getContentAnalyticsTableListErrorContainer,
          ...action.payload
        };
      })

      .addCase(getDashboardMetrics.pending, state => {
        state.isDashboardMetricsLoading = true;
        state.isDashboardMetricsSuccess = false;
        state.isDashboardMetricsFailed = false;
      })
      .addCase(getDashboardMetrics.fulfilled, (state, action) => {
        state.isDashboardMetricsLoading = false;
        state.isDashboardMetricsSuccess = true;
        state.dashboardMetrics = {
          teacherCount: action.payload?.teacherCount || 0,
          facilitatorCount: action.payload?.facilitatorCount || 0,
          schoolCount: action.payload?.schoolCount || 0,
          contentViews: action.payload?.contentViews || 0,
          contentEngagement: action.payload?.contentEngagement || 0,
          resourceCount: action.payload?.resourceCount || 0,
          totalUsers: action.payload?.totalUsers || 0,
          publishedContentCount: action.payload?.publishedContentCount || 0
        };
      })
      .addCase(getDashboardMetrics.rejected, (state, action) => {
        state.isDashboardMetricsLoading = false;
        state.isDashboardMetricsFailed = true;
        state.dashboardMetrics = initial.dashboardMetrics;
        state.dashboardMetricsErrorContainer = {
          ...state.dashboardMetricsErrorContainer,
          ...action.payload
        };
      });
  }
});
export default analyticsSlice.reducer;
